import type { VoidFunctionComponent } from 'react';
import { BUTTON_TYPE } from '../../../../../../../../../../generic/Button';
import { icons } from '../../../../../../../../../../generic';
import { useOnHover } from '../../../../../../../../../../../hooks/useOnHover';
import ProjectRowButton from '../ProjectRowButton/ProjectRowButton';

type Props = {
  isAdded: boolean;
  onAdd: () => void;
  onRemove: () => void;
  tooltip?: string;
  isDisabled?: boolean;
};

const AddRemoveButton: VoidFunctionComponent<Props> = ({
  isAdded,
  onAdd,
  onRemove,
  tooltip,
  isDisabled,
}) => {
  const { isHovered, onMouseEnter, onMouseLeave } = useOnHover();

  return isAdded ? (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {isHovered ? (
        <ProjectRowButton
          buttonType={BUTTON_TYPE.ERROR}
          icon={icons.times}
          text="Remove"
          onClick={onRemove}
        />
      ) : (
        <ProjectRowButton
          buttonType={BUTTON_TYPE.PRIMARY}
          icon={icons.check}
          text="Added"
          onClick={onRemove}
        />
      )}
    </div>
  ) : (
    <ProjectRowButton
      buttonType={BUTTON_TYPE.OUTLINE}
      icon={icons.plus}
      text="Add"
      onClick={onAdd}
      tooltip={tooltip}
      isDisabled={isDisabled}
    />
  );
};

export default AddRemoveButton;
